import { lazyLoad } from 'utils/loadable';

export const EventCategorySortListPage = lazyLoad(
  () => import('./index'),
  module => module.EventCategorySortListPage,
);
